import { useState } from "react";
import TaskIconPicker from "../TaskIconPicker";

export default function EditTaskModal({
  task,
  audience,
  setAudience,
  groups,
  selectedGroupIds,
  setSelectedGroupIds,
  onClose,
  onSave,
}) {
  const [title, setTitle] = useState(task.title);
  const [icon, setIcon] = useState(task.icon || "📘");
  const [priority, setPriority] = useState(task.priority || "required");
  const [samenwerken, setSamenwerken] = useState(!!task.samenwerken);
  const [zelfNakijken, setZelfNakijken] = useState(!!task.zelf_nakijken);
  const [feedbackEnabled, setFeedbackEnabled] = useState(
    !!task.feedback_enabled
  );
  const hasGroups = groups && groups.length > 0;

  function handleSave() {
    if (!title.trim()) return;
    onSave(
      title,
      icon,
      priority,
      audience,
      selectedGroupIds,
      samenwerken,
      zelfNakijken,
      feedbackEnabled
    );
  }

  function toggleGroup(groupId) {
    setSelectedGroupIds((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  }

  return (
    <div
      className="ct-modal-backdrop"
      onClick={onClose}
    >
      <div
        className="ct-modal ct-task-form-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ct-modal-header ct-task-form-header">
          <div className="ct-task-form-heading">
            <h2 className="ct-modal-title">Taak bewerken</h2>
            <p className="ct-panel-subtitle">Pas de taakinstellingen aan.</p>
          </div>
          <button type="button" onClick={onClose} className="ct-close-button" aria-label="Sluiten">×</button>
        </div>

        <div className="ct-task-form">
          <label className="ct-task-title-field">
            <span className="ct-form-label">Titel</span>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="ct-form-input w-full"
              placeholder="Nieuwe titel"
            />
          </label>

          <div>
            <span className="ct-form-label">Kies een icoontje</span>
            <TaskIconPicker selectedIcon={icon} onSelect={setIcon} />
          </div>

          <div className="ct-task-form-grid">
            <div className="ct-form-section">
              <span className="ct-form-label">Type taak</span>
              <div className="ct-segmented-control">
                <button type="button" className={priority === "required" ? "is-selected" : ""} onClick={() => setPriority("required")}>Moetje</button>
                <button type="button" className={priority === "optional" ? "is-selected" : ""} onClick={() => setPriority("optional")}>Magje</button>
              </div>
            </div>

            <div className="ct-form-section">
              <span className="ct-form-label">Toewijzen aan</span>
              <div className="ct-segmented-control">
                <button type="button" className={audience === "all" ? "is-selected" : ""} onClick={() => setAudience("all")}>Hele klas</button>
                <button type="button" className={audience === "targeted" ? "is-selected" : ""} onClick={() => setAudience("targeted")}>Specifiek</button>
              </div>
            </div>

            {audience === "targeted" && (
              <div className="ct-form-section ct-form-section-wide">
                <p className="ct-form-label">Groepen</p>
                {hasGroups ? (
                  <div className="flex flex-wrap gap-2">
                    {groups.map((group) => {
                      const isSelected = selectedGroupIds.includes(group.id);
                      return <button key={group.id} type="button" onClick={() => toggleGroup(group.id)} className={`ct-group-choice ${isSelected ? "is-selected" : ""}`}>{group.name}</button>;
                    })}
                  </div>
                ) : <p className="text-sm text-gray-500 italic">Nog geen groepen.</p>}
              </div>
            )}

            <div className="ct-form-section ct-form-section-wide">
              <span className="ct-form-label">Extra opties</span>
              <div className="ct-toggle-grid">
                <button type="button" className={`ct-toggle-card ${samenwerken ? "is-selected" : ""}`} aria-pressed={samenwerken} onClick={() => setSamenwerken(!samenwerken)}><span>🤝</span><span>Samenwerken</span><strong>{samenwerken ? "Aan" : "Uit"}</strong></button>
                <button type="button" className={`ct-toggle-card ${zelfNakijken ? "is-selected" : ""}`} aria-pressed={zelfNakijken} onClick={() => setZelfNakijken(!zelfNakijken)}><span>🔑</span><span>Zelf nakijken</span><strong>{zelfNakijken ? "Aan" : "Uit"}</strong></button>
                <button type="button" className={`ct-toggle-card ${feedbackEnabled ? "is-selected" : ""}`} aria-pressed={feedbackEnabled} onClick={() => setFeedbackEnabled(!feedbackEnabled)}><span>💬</span><span>Feedback vragen</span><strong>{feedbackEnabled ? "Aan" : "Uit"}</strong></button>
              </div>
            </div>
          </div>

        <div className="flex justify-end gap-3 mt-2">
          <button
            onClick={onClose}
            className="ct-button-secondary"
          >
            Annuleren
          </button>

          <button
            onClick={handleSave}
            className="ct-button-primary"
          >
            Opslaan
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
